import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 150px;
  padding: 8px;
  padding-left: 32px;
  padding-top: 12px;
  border-radius: ${({ theme }) => theme.vars.shape.borderRadius};
  background-image: ${() =>
    `url('${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/artworks/fortune-double/backgrounds/slider.png')`};
  background-repeat: no-repeat;
  background-size: 100% 100%;

  position: relative;

  @media (max-width: 768px) {
    padding: 12px 16px;
  }
`;
